var _path, _path2, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66672 4.07417C1.62137 3.77187 1.8555 3.5 2.16119 3.5H12.8388C13.1445 3.5 13.3786 3.77187 13.3333 4.07417L11.6833 15.0742C11.6466 15.3189 11.4363 15.5 11.1888 15.5H3.81119C3.56369 15.5 3.35343 15.3189 3.31672 15.0742L1.66672 4.07417Z",
    stroke: "#E31B73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70985 2.84427C4.94705 1.48888 6.124 0.5 7.5 0.5C8.876 0.5 10.053 1.48888 10.2901 2.84428L10.4049 3.5H4.5951L4.70985 2.84427Z",
    stroke: "#E31B73"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 3.25,
    width: 14.5,
    height: 0.5,
    rx: 0.25,
    fill: "#191B1E",
    stroke: "#E31B73",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 6.25,
    width: 0.5,
    height: 6.5,
    rx: 0.25,
    fill: "#191B1E",
    stroke: "#E31B73",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 6.25,
    width: 0.5,
    height: 6.5,
    rx: 0.25,
    fill: "#191B1E",
    stroke: "#E31B73",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 6.25,
    width: 0.5,
    height: 6.5,
    rx: 0.25,
    fill: "#191B1E",
    stroke: "#E31B73",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2535293b011a3f929eaa2e62b2568317.svg";
export { ForwardRef as ReactComponent };